import React from 'react';
import HeaderThin from 'app/components/layout/HeaderThin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import base64 from 'base-64';

import FixtureMatchesTable from 'app/components/fixtureMatches/FixtureMatchesTable';
import { IMatchPayment } from 'app/ducks/paymentEvents/types';

import * as matchPaymentActions from 'app/ducks/paymentEvents/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as competitionsSelectors from 'app/ducks/competitions/selectors';

interface IMatchesListProps {
  actions?: any;
  organisations?: any;
  competitions?: any;
  paymentEvents?: any;
  match?: any;
  appReady?: boolean;
  sinceTime: string;
  untilTime: string;
  locationInfoFilter: any;
}

interface IMatchesListState {
  initialFilter: any;
  error?: string;
}

function selector(state) {
  return {
    paymentEvents: paymentEventsSelectors.getPaymentEvents(state),
    organisations: organisationsSelectors.getOrganisations(state),
    competitions: competitionsSelectors.getCompetitions(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  matchPaymentActions,
);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)
export default class MatchesList extends React.Component<IMatchesListProps, IMatchesListState> {
  static defaultProps: IMatchesListProps = {
    actions: undefined,
    paymentEvents: undefined,
    match: undefined,
    appReady: false,
    sinceTime: null,
    untilTime: null,
    locationInfoFilter: {},
  };

  // componentDidMount(): void {
  //   this.props.actions.getAllMatches();
  // }

  render(): React.ReactNode {
    const filterConfig = this.props.match?.params?.filterConfig ? JSON.parse(base64.decode(this.props.match?.params?.filterConfig)) : {};

    return (
      <div className="with-margin-top">
        <FixtureMatchesTable
          {...this.props.paymentEvents}
          competitions={this.props.competitions}
          appReady={this.props.appReady}
          actions={this.props.actions}
          match={this.props.match}
          saveFilters
          showChildren
          initialFilterConfig={filterConfig}
          persistentFilterConfig={{
            filter: {
              'match-at.since': this.props.sinceTime,
              'match-at.until': this.props.untilTime,
              ...this.props.locationInfoFilter,
            },
            sort: 'match_at',
          }}
          isLoading={this.props.paymentEvents.isLoading}
          selectPaymentEvent={this.props.actions.selectPaymentEvent}
        />
      </div>
    );
  }
}
